export {
    timezones,
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
    ROWS_PER_PAGE,
    SYSTEM_COMMANDS,
};


/* FRONTEND_START_MARKER */

const ROWS_PER_PAGE = 10;

const CMD_VARIABLE = 'v';
const CMD_TABLE = 't';
const CMD_SYSTEM = 's';

const SYSTEM_COMMANDS = Object.freeze({
    REBOOT: 'E',
    INITSTTINGS: 'I',
});

const CMD_VARIABLE_ACTION = Object.freeze({
    GET: 'get',
    SET: 'set',
    GET_WIDGET_VARIABLES: 'get_w',
    CANCEL_CHANGES: 'cancel_changes',
});

const CMD_TABLE_ACTION = Object.freeze({
    GET: 'get',
    ROWS: 'rows',
    COUNT: 'count',
    ADD: 'add',
    DELETE: 'delete',
    CLEAR: 'clear',
    EDIT: 'edit',
    CANCEL_CHANGES: 'cancel_changes',
    IMPORT: 'import',
});

const CMD_SYSTEM_ACTION = Object.freeze({
    GET_AUTH: 'a_get',
    LOGIN: 'a_login',
    INFORMATION_GET: 'i_get',
    UPDATE_TIME: 'i_edit_t',
    GET_TIMEZONE: 'i_get_tz',
    UPDATE_TIMEZONE: 'i_edit_tz',
    GET_DASHBOARD_SETUP: 'get_ds',
    RUN_COMMAND: 'f_set',
    SEND_COMMAND: 's_cmd',
    GET_FIRMWARE_UPLOAD_PROGRESS: 'firmware_get_progress',
    POST_FIRMWARE_UPLOAD: 'firmware_post',
    SAVE_UNOWIRE_SENSOR: 'f_save',
    SCAN_UNOWIRE_SENSORS: 'f_scan',
    GET_UNOWIRE_SENSORS: 'f_get',
});

const timezones = [
    {
        name: 'UTC-12:00',
        value: '0',
        minutesOffset: -60 * 12,
    },
    {
        name: 'UTC-11:00',
        value: '1',
        minutesOffset: -60 * 11,
    },
    {
        name: 'UTC-10:00',
        value: '2',
        minutesOffset: -60 * 10,
    },
    {
        name: 'UTC-09:00',
        value: '3',
        minutesOffset: -60 * 9,
    },
    {
        name: 'UTC-08:00',
        value: '4',
        minutesOffset: -60 * 8,
    },
    {
        name: 'UTC-07:00',
        value: '5',
        minutesOffset: -60 * 7,
    },
    {
        name: 'UTC-06:00',
        value: '6',
        minutesOffset: -60 * 6,
    },
    {
        name: 'UTC-05:00',
        value: '7',
        minutesOffset: -60 * 5,
    },
    {
        name: 'UTC-04:00',
        value: '9',
        minutesOffset: -60 * 4,
    },
    {
        name: 'UTC-03:00',
        value: '11',
        minutesOffset: -60 * 3,
    },
    {
        name: 'UTC-02:00',
        value: '12',
        minutesOffset: -60 * 2,
    },
    {
        name: 'UTC-01:00',
        value: '13',
        minutesOffset: -60 * 1,
    },
    {
        name: 'UTC',
        value: '14',
        minutesOffset: 60 * 0,
    },
    {
        name: 'UTC+01:00',
        value: '15',
        minutesOffset: 60 * 1,
    },
    {
        name: 'UTC+02:00',
        value: '16',
        minutesOffset: 60 * 2,
    },
    {
        name: 'UTC+03:00',
        value: '17',
        minutesOffset: 60 * 3,
    },
    {
        name: 'UTC+04:00',
        value: '19',
        minutesOffset: 60 * 4,
    },
    {
        name: 'UTC+04:30',
        value: '20',
        minutesOffset: 60 * 4.5,
    },
    {
        name: 'UTC+05:00',
        value: '21',
        minutesOffset: 60 * 5,
    },
    {
        name: 'UTC+05:30',
        value: '22',
        minutesOffset: 60 * 5.5,
    },
    {
        name: 'UTC+05:45',
        value: '23',
        minutesOffset: 60 * 5.75,
    },
    {
        name: 'UTC+06:00',
        value: '24',
        minutesOffset: 60 * 6,
    },
    {
        name: 'UTC+07:00',
        value: '26',
        minutesOffset: 60 * 7,
    },
    {
        name: 'UTC+08:00',
        value: '27',
        minutesOffset: 60 * 8,
    },
    {
        name: 'UTC+09:00',
        value: '28',
        minutesOffset: 60 * 9,
    },
    {
        name: 'UTC+10:00',
        value: '30',
        minutesOffset: 60 * 10,
    },
    {
        name: 'UTC+11:00',
        value: '31',
        minutesOffset: 60 * 11,
    },
    {
        name: 'UTC+12:00',
        value: '32',
        minutesOffset: 60 * 12,
    },
    {
        name: 'UTC+13:00',
        value: '33',
        minutesOffset: 60 * 13,
    },
];
